var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8907 29.002L18.2337 34L16.5767 29.002C15.7953 26.639 13.8942 24.786 11.4698 24.0244L6.34186 22.4094L11.4698 20.7944C13.8942 20.0328 15.7953 18.1798 16.5767 15.8168L18.2337 10.8188L19.8907 15.8168C20.6721 18.1798 22.5733 20.0328 24.9977 20.7944L30.1256 22.4094L24.9977 24.0244C22.5733 24.786 20.6756 26.639 19.8907 29.002Z",
    fill: "url(#paint0_linear_937_847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26628 15.7556L6.34186 18.547L5.41744 15.7556C5.02674 14.5758 4.07442 13.6476 2.86395 13.2668L0 12.3624L2.86395 11.4614C4.07442 11.0806 5.02674 10.1524 5.41744 8.9726L6.34186 6.1812L7.26628 8.9726C7.65698 10.1524 8.6093 11.0806 9.81977 11.4614L12.6837 12.3624L9.81977 13.2634C8.6093 13.6476 7.66047 14.5724 7.26628 15.7556Z",
    fill: "url(#paint1_linear_937_847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6244 6.0282L15.0628 7.7248L14.5012 6.0282C14.2465 5.2598 13.6291 4.658 12.8407 4.4098L11.1 3.8624L12.8407 3.315C13.6291 3.0668 14.2465 2.465 14.5012 1.6966L15.0628 0L15.6244 1.6966C15.8791 2.465 16.4965 3.0668 17.2849 3.315L19.0256 3.8624L17.2849 4.4098C16.4965 4.6614 15.8791 5.2632 15.6244 6.0282Z",
    fill: "url(#paint2_linear_937_847)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_847",
    x1: 18.2337,
    y1: 10.8188,
    x2: 18.2337,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7190FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC11FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_937_847",
    x1: 6.34186,
    y1: 6.1812,
    x2: 6.34186,
    y2: 18.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7190FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC11FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_937_847",
    x1: 15.0628,
    y1: 0,
    x2: 15.0628,
    y2: 7.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7190FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC11FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.708ebab1f107abd0ecd7410ef5269091.svg";
export { ForwardRef as ReactComponent };